module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }